import React from "react";

import "./styles.less";

import { useTranslation } from "react-i18next";
import { Column, Table } from "../NormalTable";
import { AuthingButton } from "../../../../components/AuthingButton";
import { tryNow } from "../../../../utils";

export const SolutionTable = () => {
  const { t } = useTranslation();
  const data = [
    {
      nametype: t("solution.keycloak.table.fun"),
      descript: `<a href="https://docs.authing.cn/v2/concepts/authentication.html#oidc-oauth2-0-saml-ad-ldap-%E7%A4%BE%E4%BC%9A%E5%8C%96%E7%99%BB%E5%BD%95" class='table-href'">${t(
        "solution.keycloak.table.fun1"
      )}</a>`,
      dataIndex: "descript",
      okta: `<div style="text-align:center">${t(
        "solution.keycloak.table.keycloak"
      )}</div>`,
      authing: `<div style="text-align:center">${t(
        "solution.keycloak.table.authing"
      )}</div>`,
    },
    {
      nametype: (
        <img
          src="//files.authing.co/authing-website/authing-logo-0830.png"
          alt="authing"
          style={{ width: 100 }}
        />
      ),
      descript: t("solution.keycloak.table.fun2"),
      dataIndex: "authing",
      okta: "checked",
      authing: "checked",
    },
    {
      nametype: (
        <img
          src="//files.authing.co/authing-website/keycloak-logo-table.png"
          alt="authing"
          style={{ width: 108 }}
        />
      ),
      descript: `<a href="https://www.authing.cn/database-connection" class='table-href'">${t(
        "solution.keycloak.table.fun3"
      )}</a>`,
      dataIndex: "okta",
      okta: "checked",
      authing: "checked",
    },

    {
      descript: `<a href="https://www.authing.cn/authorization-management" class='table-href'">${t(
        "solution.keycloak.table.fun4"
      )}</a>`,
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://www.authing.cn/learn/guard" class='table-href'">${t(
        "solution.keycloak.table.fun5"
      )}</a>`,
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: `<a href="https://www.authing.cn/mfa" class='table-href'">${t(
        "solution.keycloak.table.fun6"
      )}</a>`,
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: t("solution.keycloak.table.fun7"),
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v3/reference/" class='table-href'">${t(
        "solution.keycloak.table.fun8"
      )}</a>`,
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: t("solution.keycloak.table.fun9"),
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: t("solution.keycloak.table.fun10"),
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/guides/authentication/extensibility/webhook.html" class='table-href'">${t(
        "solution.keycloak.table.fun11"
      )}</a>`,
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: `<a href="https://docs.authing.cn/v2/multi-tenant-console/" class='table-href'">${t(
        "solution.keycloak.table.fun12"
      )}</a>`,
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: t("solution.keycloak.table.fun13"),
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: t("solution.keycloak.table.fun14"),
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: t("solution.keycloak.table.fun15"),
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: t("solution.keycloak.table.fun16"),
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
    {
      descript: t("solution.keycloak.table.fun17"),
      dataIndex: "",
      okta: "checked",
      authing: "checked",
    },
    {
      descript: t("solution.keycloak.table.fun18"),
      dataIndex: "",
      okta: "unchecked",
      authing: "checked",
    },
  ];
  const renderChecked = (value) => {
    const iconStyl = {
      color: "#215AE5",
      textAlign: "center",
      margin: "0 auto",
      display: "block",
      // color: "rgba(57, 106, 255, 0.8)",
    };
    const uniconStyl = {
      color: "#FB9926",
      textAlign: "center",
      margin: "0 auto",
      display: "block",
      fontSize: "19px",
    };
    const checkedIcon = (
      <div>
        <i className="icon authing-icon authing-wancheng" style={iconStyl}></i>
      </div>
    );
    const uncheckedIcon = (
      <div>
        <i
          className="icon authing-icon authing-close-circle-fill1"
          style={uniconStyl}
        ></i>
      </div>
    );
    if (value === "checked") {
      return checkedIcon;
    } else if (value === "unchecked") {
      return uncheckedIcon;
    } else {
      return <div dangerouslySetInnerHTML={{ __html: value }}></div>;
    }
  };
  return (
    <>
      <div className="solution-table">
        <div className="inner">
          <div>
            <div className="solution-table-title">
              {t("solution.keycloak.table.title")}
            </div>
            <div className="solution-table-subtitle">
              {t("solution.keycloak.table.description")}
            </div>
          </div>
          <div className="solution-button-warp">
            <AuthingButton style={{ marginRight: 24 }} onClick={() => tryNow()}>
              {t("common.try-on")}
            </AuthingButton>
            <AuthingButton
              mode="light"
              onClick={() => {
                window.open(
                  "https://www.authing.cn/authingform?fromTag=替代keycloak02"
                );
              }}
            >
              {t("solution.okta.table.showDemo")}
            </AuthingButton>
          </div>
          <div className="solution-table-frame">
            <Table data={data}>
              {data.map((column) => {
                if (column.nametype) {
                  return (
                    <Column
                      title={column.nametype}
                      dataIndex={column.dataIndex}
                      render={renderChecked}
                      extra={column.extra}
                      descript={column.descript}
                    />
                  );
                } else {
                  return <></>;
                }
              })}
            </Table>
          </div>
        </div>
      </div>
    </>
  );
};
